import { Button, Paper, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { UserPollDto } from "../../../api/psc";

export default function PollListItem(props: { item: UserPollDto }) {
    return (
        <Paper sx={{ p: 1.5 }}>
            <Stack spacing={1}>
                <Typography color="primary">{props.item.title}</Typography>

                <Typography color="text.secondary">
                    {props.item.description}
                </Typography>

                {!props.item.isAnswered && (
                    <Link to={`/poll/${props.item.hashId}`}>
                        <Button fullWidth variant="contained">
                            پاسخ به نظرسنجی
                        </Button>
                    </Link>
                )}

                {props.item.isAnswered && (
                    <Button disabled variant="contained">
                        پاسخ داده شده
                    </Button>
                )}
            </Stack>
        </Paper>
    );
}
